<template>
    <div class="table table-responsive">
        <table class="table table-responsive table-striped table-bordered d-table">
            <thead>
            <tr>
                <td style="width: 10%;">Date</td>
                <td style="width: 20%;">Technician</td>
                <td>Disp</td>
                <td>Arr</td>
                <td>Dep</td>
                <td>Trvl Frm Site</td>
                <td>Total Travel</td>
                <td>HRPC</td>
                <td>TOJ</td>
                <td>Lunch</td>
                <td style="width:5%">Delete</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, itemIndex) in items" :key="item.order">
                <td>{{ date.start | dateUs }}
                    <input :readonly="readonly" :name="'times['+itemIndex+'][date_id]'" type="hidden"
                           class="form-control" v-model="item.date_id"/>
                </td>
                <td>
                    <select-component
                        :name="'times['+itemIndex+'][staff_id]'"
                        :readonly="true"
                        url-search="/users/list-of-choices"
                        :url-show="'/users/show-choice/'+item.staff_id"
                        @selected="(val) => { item.staff_id = val; save(item, itemIndex)}"
                        :initial-value="item.staff_id">
                    </select-component>
                </td>
                <td>

                    <m-time :readonly="readonly" :key="'m-time-disp-'+itemIndex" :name="'times['+itemIndex+'][disp]'"
                            @change="save(item, itemIndex, 'disp')" placeholder="00:00"
                            v-model="item.disp"></m-time>
                </td>
                <td>
                    <m-time :readonly="readonly" :key="'m-time-arriv-'+itemIndex" :name="'times['+itemIndex+'][arriv]'"
                            @change="save(item, itemIndex, 'arriv')" placeholder="00:00"
                            v-model="item.arriv"></m-time>
                </td>
                <td>
                    <m-time :readonly="readonly" :key="'m-time-dep-'+itemIndex" :name="'times['+itemIndex+'][dep]'"
                            @change="save(item, itemIndex, 'dep')" placeholder="00:00"
                            v-model="item.dep"></m-time>
                </td>
                <td>
                    <input :readonly="readonly" :name="'times['+itemIndex+'][tras]'" type="text" v-mask="'##:##'"
                           @change.prevent="save(item, itemIndex)" placeholder="00:00"
                           v-model="item.tras"
                           class="form-control form-report time"/>
                </td>
                <td>
                    <input :readonly="readonly" :name="'times['+itemIndex+'][trav]'" readonly type="text" v-mask="'##:##'"
                           placeholder="00:00"
                           v-model="item.trav"
                           class="form-control form-report time"/>
                </td>
                <td>
                    <select :disabled="readonly" class="form-control form-report" v-model="item.hrpc" :name="'times['+itemIndex+'][hrpc]'"
                            @change.prevent="save(item, itemIndex)">
                        <option value="">Please Select</option>
                        <option value="CR">Contract Rate</option>
                        <option value="R">Regular Time</option>
                        <option value="T/H">Time and Half</option>
                        <option value="DT">Double Time</option>
                        <option value="PW">Prevailing Rate</option>
                        <option value="TRV">Travel Time</option>
                        <option value="DF">Differential</option>
                    </select>
                </td>
                <td>
                    <input :readonly="readonly" :name="'times['+itemIndex+'][toj]'" readonly type="text" v-mask="'##:##'"
                           placeholder="00:00"
                           v-model="item.toj"
                           class="form-control form-report time"/>
                </td>
                <td>
                    <input :readonly="readonly" :name="'times['+itemIndex+'][lunch]'" type="text" v-mask="'##:##'" placeholder="00:00"
                           @change.prevent="save(item, itemIndex)"
                           @blur="formatTime"
                           v-model="item.lunch"
                           class="form-control form-report time"/>
                </td>

                <td><a v-if="!readonly" @click="deleteLine(item.id, itemIndex)" title="Delete"
                       class="btn btn-danger text-white"><span
                    class="fa fa-trash"></span></a></td>
            </tr>
            </tbody>
            <tfoot>
<!--            <tr>
                <th colspan="9">
                    <button @click="addLine()" type="button"
                            class="btn btn-sm"
                            data-toggle="tooltip"
                            data-original-title="Add more lines">
                        <i class="fa fa-plus"></i>
                    </button>

                </th>

            </tr>-->
            </tfoot>
        </table>
    </div>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import draggable from 'vuedraggable'
import {mask} from 'vue-the-mask'
import WorkTicketStaffModel from "../../../models/WorkTicketStaffModel";
import MTime from "../../generics/MTime.vue";

export default {
    name: "TechnicianTime",
    directives: {mask},
    components: {
        MTime,
        draggable,
    },
    props: {
        staffs: {
            type: Array,
            required: false
        },
        workTicketId: {
            required: true
        },
        date: {
            type: Object,
            default() {
                return {}
            }
        },
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            items: [],
            order: 0,
            technicians: [],
            loadingInitial: true,

        }
    },
    async mounted() {
        let app = this;
        if (this.staffs.length > 0) {
            this.items = this.staffs
            for (let i = 1; i <= this.items.length; i++) {
                this.items[i - 1]['index'] = i
                this.items[i - 1].order = i
                this.order++;
            }
            setTimeout(function () {
                app.loadingInitial = false;
            }, 1000)
        }
    },
    methods: {
        addLine() {
            let item = new WorkTicketStaffModel()
            item.order = ++this.order
            item['index'] = item.order
            this.items.push(item);
        },
        diffMinutes(x, y) {
            if (x === null || y === null || x === '' || y === '') return 0
            let ini = x.split(':')
            let fim = y.split(':')
            if (ini.length < 2 || fim.length < 2) return 0;
            let a = new Date()
            let b = new Date()
            a.setHours(ini[0])
            a.setMinutes(ini[1])
            b.setHours(fim[0])
            b.setMinutes(fim[1])
            return (b.getTime() - a.getTime()) / 1000 / 60;
        },
        convertToMinutes(time) {
            if (time === null) return -1
            if (time === undefined) return -1
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        },
        convertMinutesToTime(minutes) {
            if (minutes < 0) return null;
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            const formattedHours = String(hours).padStart(2, '0');
            const formattedMinutes = String(mins).padStart(2, '0');
            return `${formattedHours}:${formattedMinutes}`;
        },
        formatTime(item, field, index) {
            let time = item[field];
            if (!time) return time;
            let [hours, minutes] = ('' + time).split(':');

            hours = parseInt(hours);
            minutes = parseInt(minutes);

            if (isNaN(hours)) hours = 0;
            if (isNaN(minutes)) minutes = 0;

            if (field !== 'tras') {
                hours = Math.min(23, Math.max(0, hours)).toString().padStart(2, '0');
            }else{
                hours = Math.min(1000, Math.max(0, hours)).toString().padStart(2, '0');
            }

            minutes = Math.min(59, Math.max(0, minutes)).toString().padStart(2, '0');
            this.items[index][field] = `${hours}:${minutes}`;
            this.$forceUpdate();

            return this.items[index][field];
        },

        sumHours(time1, time2) {
            if (time1 === null) {
                time1 = '00:00'
            }
            if (time2 === null) {
                time2 = '00:00'
            }
            let ini = time1.split(':')
            let fim = time2.split(':')
            if (ini.length < 2 || fim.length < 2) return 0;
            let minutes = (parseInt(ini[0]) * 60 + parseInt(ini[1])) + (parseInt(fim[0]) * 60 + parseInt(fim[1]));
            return parseInt(minutes / 60).toString().padStart(2, '0') + ':' + (minutes % 60).toString().padStart(2, '0')

        },
        subHours(time1, time2) {
            if (time1 === null) {
                time1 = '00:00'
            }
            if (time2 === null) {
                time2 = '00:00'
            }
            let ini = time1.split(':')
            let fim = time2.split(':')
            if (ini.length < 2 || fim.length < 2) return 0;
            let minutes = (parseInt(ini[0]) * 60 + parseInt(ini[1])) - (parseInt(fim[0]) * 60 + parseInt(fim[1]));
            return parseInt(minutes / 60).toString().padStart(2, '0') + ':' + (minutes % 60).toString().padStart(2, '0')

        },
        diffHoursAndMinutes(x, y) {
            let minutesX = this.timeToMinutes(x);
            let minutesY = this.timeToMinutes(y);

            let minutesDiff = Math.abs(minutesX - minutesY);
            let hours = Math.floor(minutesDiff / 60);
            let minutes = minutesDiff % 60;

            return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
        },
        timeToMinutes(time) {
            if (time === null) return -1
            if (time === undefined) return -1
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        },

        deleteLine(id, itemIndex) {
            let app = this;
            if (id) {
                axios.post(URL_BASE + `/work_tickets/delete-staff/${id}`)
                    .then((response) => {
                        app.items.splice(itemIndex, 1);
                    })
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
        save(item, itemIndex, field) {
            if (this.loadingInitial) return;
            let app = this;
            item.disp = this.formatTime(item, 'disp', itemIndex);
            item.arriv = this.formatTime(item, 'arriv', itemIndex);
            item.dep = this.formatTime(item, 'dep', itemIndex);
            item.tras = this.formatTime(item, 'tras', itemIndex);
            item.lunch = this.formatTime(item, 'lunch', itemIndex);

           /* if (field === 'disp' || field === 'arriv' || field === 'dep') {
                const dispTime = this.convertToMinutes(item.disp);
                const arrivTime = this.convertToMinutes(item.arriv);
                const depTime = this.convertToMinutes(item.dep);


                if (dispTime !== -1 && arrivTime !== -1 && dispTime > arrivTime) {
                    app.loadingInitial = true;

                    alert('The dispatch time (disp) cannot be after  the arrival time');
                    this.items[itemIndex].arriv = this.convertMinutesToTime(dispTime + 1)

                    setTimeout(function () {
                        app.$forceUpdate()
                        app.loadingInitial = false;

                    }, 500)
                    return;
                }
                if (arrivTime !== -1 && depTime !== -1 && arrivTime > depTime) {
                    app.loadingInitial = true;
                    alert('The departure time (dep) cannot be before the  arrival time(Arr)');
                    this.items[itemIndex].dep = this.convertMinutesToTime(arrivTime + 60)
                    setTimeout(function () {
                        app.$forceUpdate()
                        app.loadingInitial = false;
                    }, 500)
                    return;
                }
            }*/

            item['date_id'] = this.date.id;
            item['trav'] = this.sumHours(this.diffHoursAndMinutes(item['disp'], item['arriv']), item['tras'])
            item['toj'] =  this.diffHoursAndMinutes(item['arriv'], item['dep'])

            if (item['lunch']){
                item['toj'] = this.subHours(item['toj'], item['lunch'])
            }
            app.items[itemIndex]['trav'] = item['trav'];
            app.items[itemIndex]['toj'] = item['toj'];
            if (item.id) {
                axios.post(URL_BASE + `/work_tickets/update-staff/${item.id}`, item)
                    .then((response) => {
                        //app.items[itemIndex] = response.data.data;
                    })
            } else {
                item["work_ticket_id"] = this.workTicketId
                axios.post(URL_BASE + `/work_tickets/store-staff`, item)
                    .then((response) => {
                        app.items[itemIndex] = response.data.data;
                    })

            }

        },
        checkMove: function () {

            for (let i = 0; i < this.items.length; i++) {
                this.items[i].index = i + 1;
            }
        },
        checkIsValid: function () {
            for (let i = 0; i < this.items.length; i++) {
                if (!this.items[i].disp) {

                    return {
                        isValid: false,
                        message: 'Dispatch Time is empty!'
                    }
                }

                if (!this.items[i].arriv) {
                    return {
                        isValid: false,
                        message: 'Arrival Time is empty!'
                    }
                }

                if (!this.items[i].dep) {
                    return {
                        isValid: false,
                        message: 'Departure Time is empty!'
                    }
                }
            }

            return {
                isValid: true,
                message: ''
            }
        },

        years: years
    }
}
</script>

<style scoped>
.form-report {
    min-width: 120px;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid !important;
}
</style>
